import { RECALL_AGENT_SETTINGS, RecallSettingsView, recallCounts } from '@elva/ui';
import { useWorkspaceLabel } from '@elva/platform';

/**
 * Settings · AI Brain › Recall (amendment 20).
 *
 * The link strip's counts come from `recallCounts()` — the same rows `/recall`
 * renders — rather than being written here. The page used to say 6 while the list
 * said something else, and one hand-written number was the whole cause.
 */
export function SettingsRecallAgentPage() {
  const counts = recallCounts();
  return (
    <RecallSettingsView
      value={RECALL_AGENT_SETTINGS}
      location={useWorkspaceLabel()}
      recallTotal={counts.total}
      recallRunning={counts.running}
    />
  );
}
